module.exports = __webpack_public_path__ + "img/notinterested.01ce9ff1.svg";